'use client';

import styles from './FormRequiredNote.module.scss';

function FormRequiredNote() {
  return (
    <div className={styles.requiredText}>
      「<span className={styles.required}> * </span>
      」は必須項目です。
    </div>
  );
}

export default FormRequiredNote;
